import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';

const EmptyState = ({ message = 'No data found', actionLabel, onAction }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 8,
        px: 2,
      }}
    >
      <Box
        sx={{
          width: 80,
          height: 80,
          borderRadius: '50%',
          backgroundColor: '#F9FAFD',
          border: '1px solid #E3E6ED',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 2.5,
          transition: 'transform 0.3s ease',
          '&:hover': {
            transform: 'scale(1.05)',
          },
        }}
      >
        <InboxOutlinedIcon sx={{ fontSize: 36, color: '#748194' }} />
      </Box>
      <Typography
        variant="h6"
        sx={{
          color: '#344050',
          fontWeight: 600,
          fontSize: '1.05rem',
          mb: 0.5,
        }}
      >
        {message}
      </Typography>
      <Typography
        variant="body2"
        sx={{ color: '#748194', mb: actionLabel ? 2.5 : 0 }}
      >
        Try adjusting your filters or check back later
      </Typography>
      {actionLabel && onAction && (
        <Button
          variant="contained"
          onClick={onAction}
          sx={{
            mt: 1,
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 600,
            px: 3,
            boxShadow: 'none',
            transition: 'all 0.2s ease',
            '&:hover': {
              boxShadow: '0 4px 12px rgba(44, 123, 229, 0.3)',
              transform: 'translateY(-1px)',
            },
          }}
        >
          {actionLabel}
        </Button>
      )}
    </Box>
  );
};

export default EmptyState;
